import { useEffect, useState } from 'react';
import { player, type PlaybackState } from './player';

/** Playback progress for one tag: 0 when something else is playing. */
export function usePlayback(tag: string): { playing: boolean; progress: number } {
  const [state, setState] = useState<PlaybackState>(player.current);
  useEffect(() => player.subscribe(setState), []);
  if (state.tag !== tag) return { playing: false, progress: 0 };
  return { playing: state.playing, progress: state.progress };
}

/** Stops any playback when the component using it goes away. */
export function useStopOnUnmount() {
  useEffect(() => () => player.stop(), []);
}
